import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { TableCell } from "@mui/material";
import { Box } from "@mui/system";
import type { JSX } from "react";

import { SortDirection, SortableColumn } from "./ValuationListPage";

interface SortableTableCellProps {
  column: SortableColumn;
  label: string;
  currentSortBy: SortableColumn;
  sortDirection: SortDirection;
  onSort: (column: SortableColumn) => void;
  width?: string;
  "data-cy"?: string;
}

export const SortableTableCell = ({
  column,
  label,
  currentSortBy,
  sortDirection,
  onSort,
  width,
  "data-cy": dataCy,
}: SortableTableCellProps): JSX.Element => {
  const isActive = currentSortBy === column;

  return (
    <TableCell sx={{ width }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
        }}
        onClick={() => onSort(column)}
        data-cy={dataCy}
      >
        {label}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: isActive ? "primary.main" : "action.disabled",
          }}
        >
          {!isActive ? (
            <UnfoldMoreIcon fontSize="small" />
          ) : sortDirection === "Ascending" ? (
            <KeyboardArrowUpIcon fontSize="small" />
          ) : (
            <KeyboardArrowDownIcon fontSize="small" />
          )}
        </Box>
      </Box>
    </TableCell>
  );
};
